import React from 'react';
import { Button } from 'components/Button';
import { ReturnSettlementActionControl } from './ReturnSettlementActionControl';
import { ReturnSettlementActionState } from './returnSettlementAction';

type ReturnStoreCreditActionControlsProps = {
  actionId: string;
  actionState: ReturnSettlementActionState;
  actionClassName: string;
  actionLoading?: boolean;
  needsShopifyReauthorization: boolean;
  onAction: () => void;
  onReconnect: () => void;
  reconnectLabel: string;
  reconnecting?: boolean;
};

export const ReturnStoreCreditActionControls = ({
  actionId,
  actionState,
  actionClassName,
  actionLoading = false,
  needsShopifyReauthorization,
  onAction,
  onReconnect,
  reconnectLabel,
  reconnecting = false,
}: ReturnStoreCreditActionControlsProps) => (
  <div className="flex flex-wrap items-start gap-3">
    {needsShopifyReauthorization && (
      <Button
        onClick={onReconnect}
        className="bg-indigo-600 border border-indigo-600 hover:bg-indigo-700 text-white"
        isLoading={reconnecting}
      >
        {reconnectLabel}
      </Button>
    )}

    <ReturnSettlementActionControl
      actionId={actionId}
      actionState={actionState}
      onClick={onAction}
      className={actionClassName}
      isLoading={actionLoading}
    />
  </div>
);
